/* eslint-disable no-unused-vars */

import A11yDialog from 'a11y-dialog';
import { Component } from '../core/component';

export class Newsletter extends Component {
    constructor() {
        super();
        this.selector = '[data-newsletter]';
    }

    init() {
        function newsletter() {
            let dialog = null;
            const html = document.getElementsByTagName('html')[0];
            const contentContainer = document.getElementById('main');
            const modalNewsletter = document.getElementById('modal-newsletter');

            dialog = new A11yDialog(modalNewsletter, contentContainer);

            function open() {
                if (dialog) {
                    dialog.show();
                }
            }

            function hide() {
                if (dialog) {
                    dialog.hide();
                }
            }

            // open event
            dialog.on('show', (dialogEl, event) => {
                html.classList.add('has-active-modal');
            });

            // hide event
            dialog.on('hide', (dialogEl, event) => {
                html.classList.remove('has-active-modal');
            });

            return {
                open,
                hide,
            };
        }

        global.$app.component.newsletter = newsletter();
    }
}
